import { render, staticRenderFns } from "./form-row-edit-dadata-address.vue?vue&type=template&id=732808e6&"
import script from "./form-row-edit-dadata-address.vue?vue&type=script&lang=js&"
export * from "./form-row-edit-dadata-address.vue?vue&type=script&lang=js&"
import style0 from "./form-row-edit-dadata-address.vue?vue&type=style&index=0&id=732808e6&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('732808e6')) {
      api.createRecord('732808e6', component.options)
    } else {
      api.reload('732808e6', component.options)
    }
    module.hot.accept("./form-row-edit-dadata-address.vue?vue&type=template&id=732808e6&", function () {
      api.rerender('732808e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-row-edit-dadata-address.vue"
export default component.exports